export class contactInfo {
  fullName:string;
  email:string;
  mobile:string;
  notes:string;
}
